<template>
  <div id="shopping-cart-panel" class="h-100">
    <div>
      <h5 class="px-1" v-if="!hideSaleNum"># {{ saleNumber }}</h5>
      <div id="customer-panel" class="px-1">
        <button class="select-customer-btn" @click="unselectCustomer" v-if="customer">
          <font-awesome-icon :icon="['fas', 'user-minus']"/>
        </button>
        <button class="select-customer-btn" @click="selectCustomer" v-else>
          <font-awesome-icon :icon="['fas', 'user-plus']"/>
        </button>
        <div class="customer-details" v-if="customer">
          <h6>{{ customer.Name }} {{ customer.Surname }}</h6>
          <p v-if="customer.CellNumber">cell: {{ customer.CellNumber }}</p>
          <p v-if="customer.vat">tpin: {{ customer.vat }}</p>
          <p v-if="customer.Balance">balance: {{ $utils.formatMoney(customer.Balance) }}</p>
        </div>
        <div class="customer-details" v-else>
          <h6>Select Customer</h6>
         </div>
        <div class="customer-details">
          <a v-if="$store.getters.getZedMobileStatus" class="btn fw-bold text-primary mx-2" data-bs-toggle="modal"
             data-bs-target="#exampleModal">Create Voucher</a>

        </div>

      </div>
    </div>
    <div class="sale-details-section" ref="saleLinesTable">
      <div class="shopping-cart" ref="shoppingCart" v-on:scroll="handleScroll">
        <ul class="list-group list-group-flush">
          <li class="list-group-item p-0" :key="sale.id || sale.index || `${sale.Plu}-${sale.Description}-${index}`" v-for="(sale , index) in currentSaleLines">
            <CurrentSaleLine :sale-line="sale" @open-discount-modal="handleOpenDiscountModal"/>
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex flex-row justify-content-between">
      <div :class="`sales-stats ${isScrollable?`w-75`:`w-100`} ml-auto`">
        <SaleDetails/>
        <div class="cart-actions d-flex">
          <button class="btn btn-secondary flex-fill" :disabled="disabled" :style="saveColor" @click="saveTable">
            SAVE
          </button>
          <button class="btn btn-dark flex-fill" :disabled="disabled" :style="delivery" @click="processDelivery">
            DELIVERY
          </button>
          <button class="btn btn-primary flex-fill" :disabled="disabled" :style="color" @click="process">
            PAY
          </button>
        </div>
      </div>
      <div class="scroll-controls" v-if="isScrollable">
        <button class="scroll-control" @click="scrollToTop">
          <font-awesome-icon :icon="['fas', 'chevron-up']"/>
        </button>
        <button class="scroll-control" @click="scrollToBottom">
          <font-awesome-icon :icon="['fas', 'chevron-down']"/>
        </button>
      </div>
    </div>

    <!-- Discount Modal -->
    <div class="modal fade" id="discount-modal" tabindex="-1" aria-labelledby="discount-modal-label" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="discount-modal-label">Apply Discount to {{ $utils.toPascalCase($utils.cutLength(discountModalData?.saleLine?.Description || '', 30)) }}</h5>
            <button type="button" class="btn-close" @click="closeDiscountModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="applyDiscount">
              <div class="d-flex flex-row p-1 justify-content-evenly mt-2">
                <label>
                  <input class="form-check-input" type="radio" value="value" v-model="discountType">
                  Value Discount
                </label>
                <label>
                  <input class="form-check-input" type="radio" value="percent" v-model="discountType">
                  Percentage Discount
                </label>
              </div>
              <hr class="mx-2"/>
              <label class="row mx-3 mb-2">
                Discount Amount
                <input type="number" class="form-control" v-model="discountAmount" @focus="$event.target.select()">
              </label>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-secondary me-2" @click="closeDiscountModal">Close</button>
                <button type="submit" class="btn btn-primary">Save changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import CurrentSaleLine from "@/components/point-of-sale/sales/CurrentSaleLine.vue";
import SaleDetails from "@/components/point-of-sale/sales/SaleDetails.vue";
import * as bootstrap from 'bootstrap';

export default {
  watch: {
    currentSaleLines() {
      this.scrollToBottom2();
    },
  },
  name: 'ShoppingCart',
  components: {SaleDetails, CurrentSaleLine},
  props: {
    hideSaleNum: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCategory: null,
      selectedItem: [],
      amount: '', // Bind to Amount input
      cell: '', // Bind to Phone Number input
      amountPaid: '', // Bind to Amount Paid input
      currentItem: null, // To track the currently selected item
      saleNumber: this.$route.query.saleNumber,
      dontReload: this.$route.query.dontReload,
      isScrollable: false,
      scrollPosition: 0,
      maxScrollTop: 0,
      shoppingListHeight: 1,
      resizeObserver: undefined,
      // Discount modal data
      discountModalData: null,
      discountType: 'value',
      discountAmount: 0.00
    }
  },
  mounted() {
    /* this.resizeObserver = new ResizeObserver(entries => {
      let panel = entries[0]
      if (panel) {
        let { height } = panel.contentRect
        this.shoppingListHeight = height - (salenumHeight + customerSectionHeight + salesStatsHeight)
      }
    })
    this.resizeObserver.observe(document.querySelector("#shopping-cart-panel")) */
  },
  beforeDestroy() {

  },
  computed: {
    currentSale() {
      return this.$store.getters.getCurrentSale
    },
    options() {
      return this.$store.getters.getZedMobileCategories;
    },
    tipAmount() {
      let tipAmount = this.$store.getters.getTipAmount;
      return tipAmount;
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal
    },
    disabled() {
      return this.saleTotal <= 0;
    },
    customer() {
      let id = this.$store.getters.getCustomer;
      return this.$store.getters.getDebtorByID(id);
    },
    currentSaleLines() {
      return this.$store.getters.getSaleLines
    },
    saleUnits() {
      return this.$store.getters.getSaleUnits
    },
    discount() {
      return this.$store.getters.getSaleDiscount
    },
    tipsTotal() {
      return this.$store.getters.getTipAmount;
    },
    color() {
      return this.disabled ? {background: 'grey'} : {background: '#9ccc65'}
    },

    delivery() {
      return this.disabled ? {background: 'grey'} : {background: '#37b1c6'}
    },

    saveColor() {
      return this.disabled ? {background: 'grey'} : {background: '#475f9b'}
    }
  },
  methods: {
    scrollToBottom2() {
      this.$nextTick(() => {
        const container = this.$refs.shoppingCart;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    resetAmountInputFields() {
      this.amount = '';
      this.cell = '';
      document.getElementById("amountCloseBtn").click();
    },
    handleAmountInputSave() {
      if (this.currentItem) {
        this.addToSaleWithAmount({
          ...this.currentItem,
          amount: this.amount,
          cell: this.cell,

        });
        this.resetAmountInputFields()
      }
    },
    handleCustomerInfoSave() {
      if (this.currentItem) {
        this.addToSaleWithPhoneNumber({
          ...this.currentItem,
          cell: this.cell,
        });
        this.resetCustomerInfoFields()
      }
    },
    resetCustomerInfoFields() {
      this.cell = '';
      document.getElementById("closemodal").click();
    },
    async addToSaleWithAmount(item) {
      let vat = await this.$store.dispatch(`getVatAmount`,{a : item.SellingIncl, incl : true, TaxLabels : 'A'});
      let obj = {
        Plu: item.PLU,
        Description: item.Description,
        Qty: 1,
        Unit: item.amount,
        Line: item.amount,
        Discount: 0,
        vat: 0,
        instructions: [],
        voucher: true,
        cell: item.cell || "",
        offer: item.offer || "",
      };
      this.$store.commit('addToCurrentSaleLines', obj);
      this.$store.dispatch('calculateTipAmount');
    },
    async addToSaleWithPhoneNumber(item) {
      let vat = await this.$store.dispatch(`getVatAmount`,{a : item.SellingIncl, incl : true, TaxLabels : 'A'})
      let obj = {
        Plu: item.PLU,
        Description: item.Description,
        Qty: 1,
        Unit: item.SellingIncl,
        Line: item.SellingIncl,
        Discount: 0,
        vat,
        instructions: [],
        voucher: true,
        tourismLevy : 0,
        offer: item.offer || "",
        cell: item.cell || "", // Add phoneNumber or any other required data
      };
      this.$store.commit('addToCurrentSaleLines', obj);
      this.$store.dispatch('calculateTipAmount');
    },
    checkItemOffer(item) {
      this.currentItem = item; // Track the selected item
      const hasOffer = item.offer;

      if (hasOffer) {
        this.triggerModal('openAmountInputModalButton');
      } else {
        this.triggerModal('openCustomerInformationModalButton');
      }
    },
    triggerModal(buttonId) {
      const button = document.getElementById(buttonId);
      if (button) {
        button.click();
      }
    },
    selectOption(option) {
      this.$utils.showLoading();
      this.selectedCategory = option;
      return axios.get(zedMobileApi + 'products/getByCatgeory', {
        params: {category: option},
        headers: {"Api-key": this.$store.getters.getZedMobileApiKey}
      }).then(response => this.selectedItem = response.data)
          .catch(error => errorHandler.tomcatError(error))
          .finally(() => this.$utils.hideLoading());
    },
    selectCustomer() {
      return this.$router.push({name: `select-customer`, query: {saleNumber: this.$route.query.saleNumber}})
    },
    unselectCustomer() {
      this.$store.commit(`setCustomer`, '')
    },
    close() {
      return this.$router.push({name: 'pos'})
    },
    saveTable() {
      let close = document.getElementById(`canvasClose`);
      if (close) close.click();
      if (!this.currentSale || this.currentSale === 0) {
        return this.createTable();
      }
      return this.editTable();
    },
    loadPanel() {
      return Swal.fire({
        html: 'Updating table....',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
        },
      });
    },
    editTable() {
      let settings = this.$store.getters.getDeviceSettings;
      let table = {};
      this.loadPanel()
      table.items = this.$store.getters.getSaleLines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = this.$store.getters.getOpenTableName;
      return this.$store.dispatch('updateTable', table)
          .then((result) => {
            // RESTAURANT-POS-Q: concurrent save soft-skipped — no success UX
            if (result && result.skipped) {
              return;
            }
            responses.showInfo('Table successfully updated')
            let autoLogout = settings.AutoLog === 1;
            if (autoLogout) {
              return this.$router.push({name: `poslogin`});
            }
            return this.$router.push({name: `tables`})
          }).finally(() => Swal.close())
    },
    createTable() {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        title: 'Table Name',
        icon: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'Save Table',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Table name is required`);
          this.$store.commit(`setOpenTableName`, input)
          return this.$store.dispatch('saveNewTable', {
            name: input,
            Customer: this.$store.getters.getCustomer,
          }).then((saveResult) => {
            // RESTAURANT-POS-Q: soft-skip keeps dialog open with wait message
            if (saveResult && saveResult.skipped) {
              return Swal.showValidationMessage('Save already in progress, please wait');
            }
            return input;
          })
              .catch(error => Swal.showValidationMessage(error))
        },
      }).then((result) => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return Swal.fire({
            title: `Success`,
            icon: 'success',
            text: `Table ${result.value} Saved`
          }).then(() => {
            this.$store.commit('setOpenTableName', '')
            this.$store.commit('setCurrentSale', 0)
            this.$store.dispatch("clearLocalStorage")
            return this.$router.push({name: `tables`})
          })
        }
      })
    },

    /**
     * Routes to the `payment` route to complete the sale.
     * Does NOT mutate sale state (cart/discount/tip preserved).
     * @returns {Promise} resolves when navigation has been triggered.
     */
    process() {
      return this.$router.push({name: 'payment'})
    },
    /**
     * "Delivery" click handler in the cart sidebar.
     *
     * Intended behaviour: only the tip should be cleared — cart,
     * discount, customer and table must remain so the delivery
     * payment can still be taken.
     *
     * Current behaviour: only `setTipAmount(0)` is committed before
     * navigating to the `payment` route via `process()`. Nothing else
     * is cleared by this handler.
     *
     * NOTE — investigation 2026-07-23 (Athena): Any "extra clearing"
     * perceived by Felix does NOT originate here. See related notes in
     * PaymentControls.vue (processDelivery), PaymenScreen.vue (back),
     * and the `clearSale` mutation in sales-module.js.
     */
    processDelivery() {
      this.$store.commit(`setTipAmount`, 0)
      return this.process();
    },
    scrollToTop() {
      const newScrollTop = Math.max(this.scrollPosition - 110, 0);
      this.$refs.shoppingCart.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    scrollToBottom() {
      const newScrollTop = Math.min(this.scrollPosition + 110, this.maxScrollTop);
      this.$refs.shoppingCart.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const scroll = {
        scrollTop: this.$refs.shoppingCart.scrollTop,
        scrollHeight: this.$refs.shoppingCart.scrollHeight,
        clientHeight: this.$refs.shoppingCart.clientHeight
      }
      this.scrollPosition = scroll.scrollTop
      this.maxScrollTop = scroll.scrollHeight - scroll.clientHeight
      this.isScrollable = scroll.scrollHeight > scroll.clientHeight;
    },
    handleOpenDiscountModal(data) {
      this.discountModalData = data;
      this.discountType = 'value';
      this.discountAmount = 0.00;
      this.$nextTick(() => {
        const modalEl = document.getElementById('discount-modal');
        if (modalEl) {
          const modal = new bootstrap.Modal(modalEl);
          modal.show();
        }
      });
    },
    closeDiscountModal() {
      const modalEl = document.getElementById('discount-modal');
      if (modalEl) {
        const modal = bootstrap.Modal.getInstance(modalEl);
        if (modal) modal.hide();
      }
    },
    applyDiscount() {
      if (!this.discountModalData || !this.discountModalData.saleLine) return;
      let type = this.discountType;
      let saleLine = this.discountModalData.saleLine;
      let line = Number(saleLine.Unit) * Number(saleLine.Qty);
      let discount = Number(this.discountAmount);
      if (type === 'percent') discount = (this.discountAmount / 100) * line;
      saleLine.Discount = discount;
      saleLine.Line = Number(saleLine.Line) - discount;
      this.closeDiscountModal();
    },
  }
}
</script>

<style lang="scss" scoped>
h6, h5, p {
  margin: 0;
}

p {
  font-size: 12px;
  color: #3d3939;
}

#shopping-cart-panel {
  display: flex !important;
  flex-direction: column;
  border-left: 1px solid #eee;
  padding: 0;
  position: relative;

  .scroll-controls {
    //position: absolute;
    bottom: 0 !important;
    right: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .scroll-control {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #0092f7;
      color: white;
    }
  }

  #customer-panel {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    height: 60px;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;

    .select-customer-btn {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      color: #303030;
      font-size: 22px;
    }
  }

  .sale-details-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 85%;
    overflow-y: auto;

    .shopping-cart {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .sales-stats {
      flex: 0 1 auto;
      height: 85px;
      border-top: var(--card-border);
      padding-top: 5px;
      position: absolute !important;
      bottom: 5px !important;

      .cart-actions {
        .btn {
          border-radius: 0;
          color: white;
          font-weight: 600;
          border: none;

          &.btn-primary {
            background: var(--accent-primary);
          }

          &.btn-secondary {
            background: var(--secondary-button-bg);
            color: var(--secondary-button-text);
          }

          &.btn-dark {
            background: var(--secondary-button-bg-dark);
          }
        }
      }
    }
  }
}

.sales-panel {
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;

  .sale-header {
    background: var(--card-bg);
    box-shadow: var(--card-shadow);
    border: var(--card-border);
    height: 53px;
    max-height: 55px;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;

      h2 {
        margin: 0;
      }

      button {
        width: 30px;
        background: var(--card-bg);
        font-size: 25px;
      }
    }
  }

  @media (min-height: 769px) {
    .sale-lines-table {
      height: 83vh !important;
    }
  }

  .sale-lines-table {
    flex: auto;
    overflow-y: auto;
    height: 77vh;

    .sales-list {
      list-style: none;
      padding: 0 0 130px 0;

      li {
        border: var(--card-border);
      }
    }
  }

  .sale-stats {
    position: absolute;
    background: var(--card-bg);
    border: var(--card-border);
    max-height: 163px;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.list-group-item {
  font-size: 1.5rem; /* Increased font size */
  padding: 15px 20px; /* Increased padding */
}

h4, h5, h6 {
  margin: 0;
}

.example-card-img-responsive {
  width: 80px;
  height: 65px;
  margin: 10px;
  opacity: 0.8;
}

.product-card {
  height: 110px;
  transition: 200ms ease-in-out;
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: row;
  word-wrap: break-word;

  .product-description {
    font-weight: 600;
    color: #303030;
  }

  .product-description2 {
    font-weight: 400;
    color: #303030;
  }

  .product-price {
    font-weight: 700;
    color: #322f2f;
  }

  &:hover, &:focus {
    background: #0092f7;
    color: white;
    transform: scale(1.03);

    .product-description {
      color: white;
    }

    .product-price {
      color: white;
    }
  }
}

img {
  height: 94px;
  width: 94px;
  opacity: 0.7;
  border-radius: 10px;
}

.text-sm {
  font-size: 12px !important;
}
</style>
